export class ErrorUtils{
    static isError(obj:any):obj is IError{
        return obj && obj.code && obj.message
    }
}